export default "__VITE_ASSET__SgQ7_5ie__"